<template>
<div class="opgaver-wrapper">
  <div class="title-container">
    <span>{{title}}</span>
    <span class="counter-container">
      <span>{{opgaver.length}}</span>
    </span>
  </div>
  <div v-if="opgaver.length" class="opgaver-container">
    <OpgaveKort
      v-for="opgave in opgaver"
      :key="opgave.id"
      :opgave="opgave"
      :onClick="opgaveOnClick"
    />
  </div>
  <div v-else class="opgaver-container">
    <OpgaveKort
      :opgave="undefined"
    />
  </div>
</div>
</template>

<script>
import OpgaveKort from '@/components/home/OpgaveKort.vue';
import { arrayToCommaSeparatedString } from '@/util';
export default {
  name: 'OpgaveListe',
  components: {
    OpgaveKort,
  },
  props: {
    opgaver: Array,
    title: String,
  },
  methods: {
    opgaveOnClick (opgave) {
      const { bbox, geodkobjekter, vejkode } = opgave;
      const geodkobjekterString = arrayToCommaSeparatedString(geodkobjekter);
      const bboxString = arrayToCommaSeparatedString(bbox);
      this.$router.push({
        name: 'map',
        query: {
          vejkode,
          bbox: bboxString,
          geodkobjekter: geodkobjekterString,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.opgaver-wrapper {
  padding: 30px 100px 10px 100px;
}
.title-container {
  display: flex;
  align-items: center;
  margin: 0 0 10px 10px;
  color: #B0B3C7;
  font-size: 20px;
}
.opgaver-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

.counter-container {
  background-color: #B0B3C7;
  box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  height: 23px;
  width: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  color: $background-color;
  font-size: 16px;
  font-weight: 600;
  margin-left: 10px;
}
.counter-container span {
  margin: 0;
  text-align: center;
  font-size: 14px;
}
@media (max-width: 600px) {
  .opgaver-wrapper {
    padding: 30px 0px 10px 0px;
  }
}
</style>
